<template>
  <div class="Shape" :class="{ 'Shape_optimize': notCompatible }">
    <svg width="551px" height="379px" viewBox="0 0 600 410" version="1.1" v-if="!notCompatible">
      <defs>
        <filter id="goo">
          <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="10" />
          <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo" />
          <feBlend in2="goo" in="SourceGraphic" result="mix" />
        </filter>
      </defs>

      <mask id="maska">
          <g class="blobs">
            <ellipse class="blob" cx="222.5" cy="88" rx="96.5" ry="68"></ellipse>
            <ellipse class="blob" cx="415.5" cy="311" rx="125.5" ry="68"></ellipse>
            <ellipse class="blob" cx="114" cy="168.5" rx="94" ry="100.5"></ellipse>
            <ellipse class="blob" cx="333.5" cy="135.5" rx="125.5" ry="100.5"></ellipse>
            <ellipse class="blob" cx="434" cy="239.5" rx="137" ry="125.5"></ellipse>
            <ellipse class="blob" cx="232.5" cy="230.5" rx="193.5" ry="147.5"></ellipse>
          </g>
      </mask>

      <rect x="0" y="0" mask="url(#maska)"></rect>
    </svg>  

    <img class="Shape_optim" v-if="notCompatible" src="/assets/images/shape.svg" />

    <img class="Shape_mobile" src="/assets/images/shape.svg" />
  </div>
</template>

<script>

import { TweenMax } from 'gsap'

export default {
  methods: {

  },
  data () {
    return {
      notCompatible:false
    }
  },
  created()
  {
    var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS')
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
    var isIE = navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)
    var isEdge = navigator.userAgent.indexOf('Edge') > 0

    if (isSafari || this.$tools.isMobile() || isFirefox || isEdge || isIE) { this.notCompatible = true }
  },
  mounted()
  {

    if(this.$tools.isMobile() && this.$el.classList.contains('Shape_indice') || !this.$el.querySelector('svg'))
      return

    var radius = 8;
    TweenMax.staggerFromTo('.blob', 4 ,{
        cycle: {
            attr:function(i) {
                var r = i*90;
                return {
                    transform:'rotate('+r+') translate('+radius+',0.1) rotate('+(-r)+')'
                }      
            }
        }  
    },{
        cycle: {
            attr:function(i) {
                var r = i*90+360;
                return {
                    transform:'rotate('+r+') translate('+radius+',0.1) rotate('+(-r)+')'
                }      
            }
        },
        ease:Linear.easeNone,
        repeat:-1
    });
  }
}
</script>

<style lang="stylus" scoped>

  .Shape

    position absolute
    top 50%
    left 52%
    opacity 0
    transform translate(-50%, -50%) scale(0.3)
    transition 1s cubic-bezier(0.165, 0.84, 0.44, 1.2)

    &_optimize

      height 390px
      width 560px

    &_mobile

      width 100%
      height 100%
      position absolute
      top 0px
      left 0px
      display none
      backface-visibility hidden
      animation back 5s linear infinite alternate backwards

      @media $large

        display block

    &_optim

      width 100%
      height 100%
      position absolute
      top 0px
      left 0px
      backface-visibility hidden
      animation back 5s linear infinite alternate backwards
      
      @media $small

        display none

    &_content

      transform translate(-50%, -50%) scale(2.3)
      opacity 1

      @media $small

        transform none!important
        position fixed!important
        top 0px!important
        left 0px!important
        height 100%!important
        width 100%!important
        background-color #d9f0ff

        img, svg

          opacity 0!important


    &_load

      transform translate(-55%, -50%) scale(1.2) scaleX(0.8)
      opacity 1

    &_message

      transform translate(-55%, -50%) scale(1.1) scaleX(1.3)!important
      opacity 1

    &_indice

      transform translate(-55%, -50%) scale(1.6)
      opacity 1

      @media $small

        transform translate(-48%, -50%) scale(1.85) scaleX(0.85)!important

    @media $large

      height 390px
      width 560px

      svg

        display none

    // @media $small

    //   position fixed
    //   top 0px
    //   left 0px
    //   transform none
    //   height 100%
    //   width 100%
    //   background #D9F0FF

    //   svg 

    //     display none

    rect {
      -webkit-transform-origin: 50% 50%;
      transform-origin: 50% 50%;
      fill: #D9F0FF;
      width 100%
      height 100%
    }

    .blobs {
      -webkit-filter: url("#goo");
      filter: url("#goo");
    }

    .blob {
      fill: white;
      will-change: transform;
    }

    &.is-open

      img

        transform scale(1.25) rotate(-3deg)
        transition transform 1.4s $ease

 

// .safari

//   svg

//     display none

//   .Shape

//     height 390px
//     width 560px

//     @media $small

//       height 100%
//       width 100%

//   .Shape_optim

//     display block

//     @media $small

//       display none
</style>
